import * as swcHelpers from '@swc/helpers';
import { LineItemType, BundleLineItemType } from '../../../__generated__/sharedTypes.js';

function getPrescriptionGlassesDetails(prescription) {
    switch(prescription.type){
        case 'email-prescription':
            return {
                isEmailPrescription: true
            };
        case 'existing-customer':
            return {
                isExistingCustomer: true
            };
        case 'new-prescription':
            return {
                newPrescription: swcHelpers.objectSpread({}, prescription.details)
            };
        case 'prescription-file':
            {
                const { prescriptionFile , pupillaryDistanceFile , left , right  } = prescription.details;
                // The server payload uses axis but it has been deprecated in favor of axisInt
                // However, the BE is not yet ready so we need to change the axisInt to axis
                const leftLens = swcHelpers.objectSpread({}, left);
                if (leftLens.axisInt) {
                    leftLens.axis = leftLens.axisInt;
                    delete leftLens.axisInt;
                }
                const rightLens = swcHelpers.objectSpread({}, right);
                if (rightLens.axisInt) {
                    rightLens.axis = rightLens.axisInt;
                    delete rightLens.axisInt;
                }
                const hasOcr = Boolean(left && right);
                return swcHelpers.objectSpread({}, hasOcr ? {
                    newPrescription: {
                        leftLens,
                        rightLens
                    }
                } : undefined, {
                    prescriptionFile: {
                        fileName: prescriptionFile.fileName,
                        storageToken: prescriptionFile.storageToken
                    },
                    pupillaryDistanceFile: {
                        fileName: pupillaryDistanceFile.fileName,
                        storageToken: pupillaryDistanceFile.storageToken
                    }
                });
            }
    }
}
const mapPrescriptionGlassesLineItem = ({ sku , quantity , bundleLineItems , prescription  })=>{
    const mainBundleLineItem = {
        sku,
        quantity: 1,
        isMainBundleLineItem: true
    };
    var _quantity;
    return {
        sku,
        quantity: quantity !== null && quantity !== void 0 ? quantity : 1,
        lineItemType: LineItemType.BUNDLE,
        bundleLineItemsType: BundleLineItemType.PRESCRIPTION_GLASSES,
        bundleLineItems: [
            mainBundleLineItem,
            ...bundleLineItems.map((item)=>swcHelpers.objectSpread({}, item, {
                    quantity: (_quantity = item.quantity) !== null && _quantity !== void 0 ? _quantity : 1,
                    isMainBundleLineItem: false
                })
            ), 
        ],
        typeDetails: getPrescriptionGlassesDetails(prescription)
    };
};

export { mapPrescriptionGlassesLineItem };
//# sourceMappingURL=prescription-glasses.js.map
